import { InputLabel, InputLabelProps, styled } from '@mui/material'

export interface MyInputLabelProps extends InputLabelProps {}

/**
 * MyInputLabel: Redefinición estilizada de InputLabel con máscara
 * para cortar limpiamente el borde de los contenedores Outlined.
 * @author isi-template
 */
export const MyInputLabel = styled((props: MyInputLabelProps) => {
  return <InputLabel color="primary" shrink={true} {...props} />
})(({ theme }) => {
  const paperBg = theme.palette.background.paper

  return {
    transform: 'translate(14px, -9px) scale(0.75)',
    pointerEvents: 'none',
    // 1. AUMENTAR EL Z-INDEX: Garantiza que el label esté por encima del borde de react-select
    zIndex: 5,
    maxWidth: 'calc(100% - 24px)',

    // Compensación de padding
    paddingLeft: 4,
    paddingRight: 4,
    marginLeft: -4,

    // 2. FONDO SÓLIDO (Recomendado):
    // Es más robusto que el gradiente para ocultar la línea y es lo que
    // suelen usar las integraciones manuales de MUI.
    backgroundColor: paperBg,

    /*
     * ALTERNATIVA CON GRADIENTE (Si tu fondo no es uniforme):
     * Si necesitas mantener el gradiente porque tienes un fondo texturizado,
     * amplía un poco los porcentajes centrales para asegurar que cubran
     * el grosor del borde (ej. 30% a 70%).
     *
     * background: \`linear-gradient(180deg,
     *   transparent 0%,
     *   transparent 30%,
     *   \${paperBg} 30%,
     *   \${paperBg} 70%,
     *   transparent 70%,
     *   transparent 100%
     * )\`,
     */

    '&.Mui-focused': {
      // Si usas backgroundColor sólido arriba, solo necesitas el color del texto aquí (MUI lo maneja).
      // Si usas el gradiente, asegúrate de replicar la misma regla ampliada aquí.
    },
  }
})
